import React, { useEffect, memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import styles from './PinPopTray.module.less';
import { PCStoreJsBridge } from '../../nativeapi';
import { logging } from '../../actions/log';
import { setTrayDialogVisible } from '../../actions/layout';
import { logNative } from '../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectDownloadSofts = createSelector(
  state => state.downloadTask,
  downloadTask => downloadTask.softs,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const softs = useSelector(selectDownloadSofts);

  const handleSure = useCallback(() => {
    // 快捷方式弹窗 直接退出
    dispatch(
      logging({
        category: 'C',
        action: 'Taskbar_Tray_Y',
        label: '',
        param2: {
          source: 'Taskbar_Tray',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          openTime: window.PC_STORE_START_HTML_LOAD_END,
          closeTime: +new Date(),
          openTimeDiff: +new Date() - window.PC_STORE_START_HTML_LOAD_END,
        },
      }),
    );

    const errorClose = error => {
      PCStoreJsBridge.closeWindow();
      logNative(`关闭商店前操作，接口异常 ${error}`);
    };

    try {
      PCStoreJsBridge.storeTrayGetIsCreate().then(res => {
        if (res && res?.succ === true) {
          if (res?.exist === false) {
            PCStoreJsBridge.setAppStoreSwitch({
              type: 101,
              enable: true,
              source: 1,
            }).then(res2 => {
              // 创建托盘
              PCStoreJsBridge.storeTrayCreate({
                type: 1,
              }).then(res1 => {
                PCStoreJsBridge.closeWindow();
              }, errorClose);
            }, errorClose);
          }
        }
      }, errorClose);
    } catch (error) {
      errorClose();
    }
  }, [dispatch, softs]);

  const handleClosePin = useCallback(
    flag => {
      // 快捷方式弹窗 暂不退出 关闭弹窗
      dispatch(
        logging({
          category: 'C',
          action: 'Taskbar_Tray_N',
          label: '',
          param2: {
            source: 'Taskbar_Tray',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            openTime: window.PC_STORE_START_HTML_LOAD_END,
            closeTime: +new Date(),
            openTimeDiff: +new Date() - window.PC_STORE_START_HTML_LOAD_END,
          },
        }),
      );
      setTimeout(() => {
        PCStoreJsBridge.closeWindow();
      }, 300);
    },
    [dispatch],
  );
  const handleCancle = useCallback(() => {
    dispatch(setTrayDialogVisible({ isShow: false }));
  });

  useEffect(() => {
    // 快捷方式弹窗 PV
    dispatch(
      logging({
        category: 'P',
        action: 'Taskbar_Tray',
        label: '',
        param2: {
          source: 'Taskbar_Tray',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, [dispatch]);

  return (
    <div className={styles.pinpop}>
      <div className="header">
        <span className="title">温馨提示</span>
        <span className="close iconfont icon-close" onClick={() => handleCancle()} />
      </div>
      <div className="message">是否最小化到托盘，常用入口，快速直达</div>
      <div className="btn_wrapper">
        <span className="btn_default" onClick={() => handleClosePin()}>
          否
        </span>
        <span className="btn_primary" onClick={() => handleSure()}>
          是
        </span>
      </div>
    </div>
  );
});
